import type { PaginationDto } from "core/dto";
import { ORDER_BY } from "core/interfaces";

export const getPaginationDefault = (): PaginationDto => ({
	page: 1,
	limit: 100,
	column: "createdAt",
	orderBy: ORDER_BY.DESC,
	search: ""
});
